module.exports = "/virtual-football/img/video/clubs/italy/roma.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/italy/roma.png
// module id = 303
// module chunks = 6